document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.product-page');
  if (!wrapper) return;

  var product;
  try {
    product = JSON.parse(wrapper.dataset.productJson);
  } catch (e) {
    return;
  }

  var form = document.getElementById('ProductForm');
  var hiddenSelect = document.getElementById('ProductSelectVariant');
  var optionSelects = form ? form.querySelectorAll('.product-form__option select') : [];
  var priceEl = document.querySelector('.product-info__price');
  var mainImage = document.getElementById('ProductMainImage');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant() {
    var selected = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
    if (selected.length === 0) return product.variants[0];
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return selected[i] === undefined || opt === selected[i]; });
    });
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;

    if (hiddenSelect) hiddenSelect.value = variant.id;

    var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to Cart';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold Out';
      }
    }

    if (priceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="price--compare">' + money(variant.compare_at_price) + '</span>' +
          '<span class="price--sale">' + money(variant.price) + '</span>';
      } else {
        priceEl.textContent = money(variant.price);
      }
    }

    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '$1');
    }
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', updateUI);
  });
});
